import { route } from 'quasar/wrappers'
import { createRouter, createMemoryHistory, createWebHistory, createWebHashHistory } from 'vue-router'
import routes from './routes'

import { useincidentsStore } from "stores/incidentsStore";
/*
 * If not building with SSR mode, you can
 * directly export the Router instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Router instance.
 */

export default route(function (/* { store, ssrContext } */) {
  const createHistory = process.env.SERVER
    ? createMemoryHistory
    : (process.env.VUE_ROUTER_MODE === 'history' ? createWebHistory : createWebHashHistory)

  const Router = createRouter({
    scrollBehavior: () => ({ left: 0, top: 0 }),
    routes,

    // Leave this as is and make changes in quasar.conf.js instead!
    // quasar.conf.js -> build -> vueRouterMode
    // quasar.conf.js -> build -> publicPath
    history: createHistory(process.env.MODE === 'ssr' ? void 0 : process.env.VUE_ROUTER_BASE)
  })
  const store = useincidentsStore();
  Router.beforeEach((to, from, next) => {
    // next();
    // return;

    if (!to.params.tenant) {
      if (to.name != 'Error')
        next({ name: 'Error' });
      else
        next();
    } else if (to.matched.some(record => record.meta.basicAuthentification)) {
      if (!store.password) {
        next({ path: '/' + to.params.tenant + '/check', query: { i: to.params.id } })
      } else {
        next() // go to wherever I'm going
      }
    } else if (to.matched.some(record => record.meta.noAuthentification)) {
      next();
    } else {
      // this route requires auth, check if logged in
      // if not, redirect to login page.
      if (!store.user) {
        // no user, we check to be sure there is no active session
        store.loadLoggedinUser(to.params.tenant)
          .catch(() => {
            next({ path: '/' + to.params.tenant + '/login', query: { r: to.href.replace('#', '') } });
          })
          .then(() => {
            if (!store.user) {
              next({ path: '/' + to.params.tenant + '/login', query: { r: to.href.replace('#', '') } })
            } else {
              next();
            }
          });
      } else if (store.user.role != 'admin' && to.name == 'Settings') {
        next('/' + to.params.tenant + '/dashboard');
      } else {
        next() // go to wherever I'm going
      }
    }
  })
  return Router
})
